// src/pages/Resources.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { resourcesAPI } from '../services/api';
import toast from 'react-hot-toast';
import { Search, Plus, RefreshCw, MapPin, Briefcase, Phone, Mail, Eye, Trash2, ChevronRight ,Filter,X} from 'lucide-react';

const EMPLOYEE_TYPES = ['CDI','INTERCO','STAGIAIRE','ALTERNANT','COMMERCIAL','EXTERNE','FREELANCE'];
const STATUSES       = ['ACTIF','INTERCONTRAT','CONGE','INACTIF','SORTI'];

const TYPE_META = {
  CDI:        { color:'#FF4100', bg:'var(--orange-50)' },
  INTERCO:    { color:'#F59E0B', bg:'#FFFBEB' },
  STAGIAIRE:  { color:'#A78BFA', bg:'rgba(139,92,246,0.10)' },
  ALTERNANT:  { color:'#06B6D4', bg:'rgba(8,145,178,0.10)' },
  COMMERCIAL: { color:'#EA580C', bg:'#FFF7ED' },
  EXTERNE:    { color:'var(--text-muted)', bg:'rgba(255,255,255,0.06)' },
  FREELANCE:  { color:'#16A34A', bg:'rgba(34,197,94,0.08)' },
};
const STATUS_META = {
  ACTIF:        { color:'#16A34A', bg:'rgba(34,197,94,0.08)' },
  INTERCONTRAT: { color:'#F59E0B', bg:'#FFFBEB' },
  CONGE:        { color:'#06B6D4', bg:'rgba(8,145,178,0.10)' },
  INACTIF:      { color:'var(--text-muted)', bg:'rgba(255,255,255,0.06)' },
  SORTI:        { color:'#DC2626', bg:'rgba(239,68,68,0.12)' },
};

export default function Resources() {
  const navigate = useNavigate();
  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');
const [filters, setFilters] = useState({
  employee_type: '',
  status: '',
  manager: '',
  client: ''
});

const [showFilters, setShowFilters] = useState(false);
const [managerOptions, setManagerOptions] = useState([]);

/*
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (search)  params.search        = search;
     if (filters.status)
  params.status = filters.status;

if (filters.employee_type)
  params.employee_type = filters.employee_type;

if (filters.manager)
  params.manager = filters.manager;

if (filters.client)
  params.client = filters.client;
      const res = await resourcesAPI.list(params);
      setItems(res.data || []);
    } catch { toast.error('Erreur chargement ressources'); }
    finally { setLoading(false); }
  }, [search, filters]);*/
const fetchData = useCallback(async () => {
  setLoading(true);

  try {
    const params = {};

    if (search)
      params.search = search;

    if (filters.status)
      params.status = filters.status;

    if (filters.employee_type)
      params.employee_type = filters.employee_type;

    if (filters.client)
      params.client = filters.client;

    const res = await resourcesAPI.list(params);

    let data = res.data || [];

    // Construction de la liste des managers disponibles (avant filtrage manager)
    const uniqueManagers = [...new Set(
      data.map(r => r.manager_name).filter(Boolean)
    )].sort((a, b) => a.localeCompare(b));
    setManagerOptions(uniqueManagers);

    // Filtrage exact du manager côté React
    if (filters.manager) {
      data = data.filter(r => r.manager_name === filters.manager);
    }

    setItems(data);

  } catch (err) {
    toast.error('Erreur chargement ressources');
  } finally {
    setLoading(false);
  }
}, [search, filters]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleDelete = async (e, id) => {
    e.stopPropagation();
    if (!window.confirm('Supprimer cette ressource ?')) return;
    try { await resourcesAPI.delete(id); toast.success('Supprimé'); fetchData(); }
    catch { toast.error('Erreur suppression'); }
  };
const hasFilters = Object.values(filters).some(Boolean);
  return (
    <div>
      <div className="page-header">
        <div className="page-header-left">
          <h1>Ressources ESN</h1>
          <p>Collaborateurs internes — CDI, interco, stagiaires, alternants...</p>
        </div>
        <div className="page-header-actions">
          <button
  className="btn btn-secondary"
  onClick={() => setShowFilters(s => !s)}
>
  <Filter size={15}/>
  Filtres

  {hasFilters && (
    <span
      style={{
        marginLeft:4,
        background:'#FF4100',
        color:'white',
        borderRadius:'50%',
        width:16,
        height:16,
        display:'inline-flex',
        alignItems:'center',
        justifyContent:'center',
        fontSize:'0.6rem'
      }}
    >
      {Object.values(filters).filter(Boolean).length}
    </span>
  )}
</button>

<button
  className="btn btn-secondary"
  onClick={fetchData}
>
  <RefreshCw size={15}/>
</button>
          <button className="btn btn-primary" onClick={() => navigate('/resources/new')}>
            <Plus size={15}/> Nouvelle ressource
          </button>
        </div>
      </div>

  <div style={{ display:'flex', gap:10, marginBottom:16 }}>
  <div style={{ position:'relative', flex:1 }}>
    <Search
      size={14}
      style={{
        position:'absolute',
        left:10,
        top:'50%',
        transform:'translateY(-50%)',
        color:'var(--text-muted)'
      }}
    />

    <input
      style={{
        paddingLeft:34,
        height:38,
        border:'1px solid var(--border)',
        borderRadius:8,
        width:'100%'
      }}
      placeholder="Nom, poste, client, email…"
      value={search}
      onChange={e => setSearch(e.target.value)}
    />
  </div>

  {(search || hasFilters) && (
    <button
      className="btn btn-ghost btn-sm"
      onClick={() => {
        setSearch('');
        setFilters({
          employee_type:'',
          status:'',
          manager:'',
          client:''
        });
      }}
    >
      <X size={14}/>
      Réinitialiser
    </button>
  )}
</div>
{showFilters && (
  <div className="card" style={{ marginBottom:16, padding:'14px 16px' }}>
    <div
      style={{
        display:'grid',
        gridTemplateColumns:'repeat(4,1fr)',
        gap:10
      }}
    >
      <div>
        <label style={lbl}>Type</label>
        <select
          className="filter-select"
          style={{ width:'100%' }}
          value={filters.employee_type}
          onChange={e =>
            setFilters(p => ({
              ...p,
              employee_type:e.target.value
            }))
          }
        >
          <option value="">Tous</option>
          {EMPLOYEE_TYPES.map(t => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </div>

      <div>
        <label style={lbl}>Statut</label>
        <select
          className="filter-select"
          style={{ width:'100%' }}
          value={filters.status}
          onChange={e =>
            setFilters(p => ({
              ...p,
              status:e.target.value
            }))
          }
        >
          <option value="">Tous</option>
          {STATUSES.map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>

      <div>
  <label style={lbl}>Manager</label>
  <select
    className="filter-select"
    style={{ width:'100%' }}
    value={filters.manager}
    onChange={e =>
      setFilters(p => ({
        ...p,
        manager: e.target.value
      }))
    }
  >
    <option value="">Tous</option>
    {managerOptions.map(m => (
      <option key={m} value={m}>{m}</option>
    ))}
  </select>
</div>

      <div>
        <label style={lbl}>Client</label>
        <input
          style={inp}
          placeholder="Client..."
          value={filters.client}
          onChange={e =>
            setFilters(p => ({
              ...p,
              client:e.target.value
            }))
          }
        />
      </div>
    </div>
  </div>
)}

      <div style={{ fontSize:'0.8125rem', color:'var(--text-muted)', marginBottom:12 }}>
        {loading ? 'Chargement…' : `${items.length} ressource${items.length !== 1 ? 's' : ''}`}
      </div>

      {loading ? (
        <div style={{ display:'flex', justifyContent:'center', padding:'48px 0', gap:10, color:'var(--text-muted)' }}>
          <div className="spinner"/> Chargement…
        </div>
      ) : items.length === 0 ? (
        <div className="card" style={{ textAlign:'center', padding:'48px 0' }}>
          <Briefcase size={36} style={{ opacity:0.3, marginBottom:12 }}/>
          <div style={{ fontWeight:600, marginBottom:6 }}>Aucune ressource</div>
          <div style={{ fontSize:'0.875rem', color:'var(--text-muted)', marginBottom:20 }}>Ajoutez vos premiers collaborateurs</div>
          <button className="btn btn-primary" onClick={() => navigate('/resources/new')}><Plus size={15}/> Ajouter</button>
        </div>
      ) : (
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Collaborateur</th><th>En sourcing</th><th>Type</th><th>Statut</th>
                  <th>Mission actuelle</th><th>Contact</th><th>Manager</th><th></th>
                </tr>
              </thead>
              <tbody>
                {items.map(r => {
                  const tm = TYPE_META[r.employee_type]   || { color:'var(--text-muted)', bg:'rgba(255,255,255,0.06)' };
                  const sm = STATUS_META[r.status]        || { color:'var(--text-muted)', bg:'rgba(255,255,255,0.06)' };
                  return (
                    <tr key={r.id} style={{ cursor:'pointer' }} onClick={() => navigate(`/resources/${r.id}`)}>
                      <td>
                        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                          <div className="avatar avatar-sm">{(r.full_name||'?')[0]}</div>
                          <div>
                            <div style={{ fontWeight:600, fontSize:'0.875rem' }}>{r.full_name}</div>
                            <div style={{ fontSize:'0.75rem', color:'var(--text-muted)' }}>{r.title || '—'}</div>
                          </div>
                        </div>
                      </td>
                      <td style={{ fontSize:'0.8125rem' }}>
                        <span style={{ 
                          padding:'2px 8px', 
                          borderRadius:4, 
                          fontWeight:600,
                          fontSize:'0.7rem',
                          background: r.is_related_to_ao ? 'rgba(22,163,74,0.1)' : 'rgba(220,38,38,0.1)',
                          color: r.is_related_to_ao ? '#16A34A' : '#DC2626',
                          textTransform: 'uppercase'
                        }}>
                          {r.is_related_to_ao ? 'Oui' : 'Non'}
                        </span>
                      </td>
                      <td>
                        <span style={{ padding:'2px 10px', borderRadius:20, fontSize:'0.75rem', fontWeight:700, background:tm.bg, color:tm.color }}>
                          {r.employee_type}
                        </span>
                      </td>
                      <td>
                        <span style={{ padding:'2px 10px', borderRadius:20, fontSize:'0.75rem', fontWeight:700, background:sm.bg, color:sm.color }}>
                          {r.status}
                        </span>
                      </td>
                      <td style={{ fontSize:'0.8125rem' }}>
                        {r.current_client
                          ? <><div style={{ fontWeight:500 }}>{r.current_client}</div><div style={{ fontSize:'0.75rem', color:'var(--text-muted)' }}>{r.current_mission}</div></>
                          : <span style={{ color:'var(--text-muted)' }}>—</span>}
                      </td>
                      <td style={{ fontSize:'0.8125rem' }}>
                        {r.email && <div style={{ display:'flex', alignItems:'center', gap:4 }}><Mail size={12}/>{r.email}</div>}
                        {r.phone && <div style={{ display:'flex', alignItems:'center', gap:4, color:'var(--text-muted)' }}><Phone size={12}/>{r.phone}</div>}
                      </td>
                      <td style={{ fontSize:'0.8125rem', color:'var(--text-muted)' }}>{r.manager_name || '—'}</td>
                      <td onClick={e => e.stopPropagation()} style={{ display:'flex', gap:6 }}>
                        <button className="btn btn-ghost btn-icon btn-sm" onClick={() => navigate(`/resources/${r.id}`)}>
                          <Eye size={14}/>
                        </button>
                        <button className="btn btn-ghost btn-icon btn-sm" style={{ color:'#DC2626' }}
                          onClick={e => handleDelete(e, r.id)}>
                          <Trash2 size={14}/>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
const lbl = {
  display:'block',
  fontSize:'0.75rem',
  fontWeight:600,
  color:'var(--text-muted)',
  marginBottom:4,
  textTransform:'uppercase',
  letterSpacing:'0.04em'
};

const inp = {
  width:'100%',
  padding:'8px 10px',
  border:'1.5px solid var(--border)',
  borderRadius:7,
  fontSize:'0.875rem',
  boxSizing:'border-box',
  fontFamily:'inherit',
  outline:'none',
  background:'var(--bg-elevated)',
  color:'var(--text-primary)'
};
